import { NCertInfo } from 'scbk-services';
import { dateUtils } from 'scbk-shared-module';

// subjectDn에서 name 얻기
export const getUserName = (subjectDn: string) => {
  if (!subjectDn) {
    return '';
  }

  if (subjectDn.lastIndexOf('(') > -1) {
    return subjectDn.substr(0, subjectDn.lastIndexOf('('));
  } else {
    return subjectDn;
  }
};

// 스토리지 코드로 변환
export const getStorage = (storagetype: NCertInfo['storagetype']) => {
  if (storagetype === 'ubikey') {
    return '1';
  }
  return '0';
};

// 발급기관 한글 치환
export const getKoreanIssuer = (issuer: string) => {
  if (!issuer) {
    return '';
  }

  if (issuer.toLowerCase().indexOf('yessign') > -1) {
    return '금융결제원';
  } else if (issuer.toLowerCase().indexOf('tradesign') > -1) {
    return '한국무역정보통신';
  } else if (issuer.toLowerCase().indexOf('crosscert') > -1) {
    return '한국전자인증';
  } else if (issuer.toLowerCase().indexOf('signkorea') > -1) {
    return '(주)코스콤';
  } else if (issuer.toLowerCase().indexOf('kica') > -1) {
    return '한국정보인증';
  } else if (issuer.toLowerCase().indexOf('inipass') > -1) {
    return '이니텍(주)';
  } else {
    return '';
  }
};

// 만료인증서 필터링
export const getNotExpiredCertList = (certList: NCertInfo[]) => {
  return certList.filter((item) => Number(dateUtils.getToday()) <= Number(item.expiredate));
};
